// ##############################
// // // table head data and table body data for Tables view
// #############################

const thead = [
  "ลำดับที่",
  "ชื่อ-นามสกุล",
  "ตำบล",
  "อำเภอ",
  "จังหวัด",
  "อาชีพ",
  "เบอร์ติดต่อ"
];
const tbody = [
  {
    data: [
      "1",
      "ตัวอย่าง ตัวอย่าง",
      "ในเมือง",
      "เมือง",
      "ขอนแก่น",
      "แม่บ้าน",
      "099-9999999"
    ]
  },
  {
    data: [
      "2",
      "ตัวอย่าง ตัวอย่าง",
      "ในเมือง",
      "เมือง",
      "ขอนแก่น",
      "แม่บ้าน",
      "099-9999999"
    ]
  },
  {
    data: [
      "3",
      "ตัวอย่าง ตัวอย่าง",
      "ในเมือง",
      "เมือง",
      "ขอนแก่น",
      "แม่บ้าน",
      "099-9999999"
    ]
  },
  {
    data: [
      "4",
      "ตัวอย่าง ตัวอย่าง",
      "ในเมือง",
      "เมือง",
      "ขอนแก่น",
      "แม่บ้าน",
      "099-9999999"
    ]
  },
  {
    data: [
      "5",
      "ตัวอย่าง ตัวอย่าง",
      "ในเมือง",
      "เมือง",
      "ขอนแก่น",
      "แม่บ้าน",
      "099-9999999"
    ]
  },
  {
    data: [
      "6",
      "ตัวอย่าง ตัวอย่าง",
      "ในเมือง",
      "เมือง",
      "ขอนแก่น",
      "แม่บ้าน",
      "099-9999999"
    ]
  },
  {
    data: [
      "7",
      "ตัวอย่าง ตัวอย่าง",
      "ในเมือง",
      "เมือง",
      "ขอนแก่น",
      "แม่บ้าน",
      "099-9999999"
    ]
  },
  {
    data: [
      "8",
      "ตัวอย่าง ตัวอย่าง",
      "ในเมือง",
      "เมือง",
      "ขอนแก่น",
      "แม่บ้าน",
      "099-9999999"
    ]
  },
  {
    data: [
      "9",
      "ตัวอย่าง ตัวอย่าง",
      "ในเมือง",
      "เมือง",
      "ขอนแก่น",
      "แม่บ้าน",
      "099-9999999"
    ]
  },
  {
    data: [
      "10",
      "ตัวอย่าง ตัวอย่าง",
      "ในเมือง",
      "เมือง",
      "ขอนแก่น",
      "แม่บ้าน",
      "099-9999999"
    ]
  }
];

// data for <thead> of table in TableList view
// data for <tbody> of table in TableList view
export { thead, tbody };
